var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffer1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 207,
    viewBox: "0 0 154 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8338 24.7891C60.8848 38.8583 56.0999 64.308 92.9075 70.4592C70.0586 73.7571 61.3271 91.4177 60.8381 114.071C60.2778 96.9715 62.623 77.2268 25.1387 71.8149C61.1153 68.9704 60.6162 39.2477 60.8338 24.7891Z",
    fill: "white",
    stroke: "#FFC200",
    strokeWidth: 8.87143,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5563 93.4258C96.6073 107.495 87.0235 133.618 123.831 139.769C100.982 143.067 97.0496 160.054 96.5606 182.708C96.0003 165.607 94.8544 145.713 68.8545 140.006C94.0561 136.999 93.631 112.625 96.5563 93.4258Z",
    fill: "white",
    stroke: "#FFC200",
    strokeWidth: 8.87143,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.793 20.6992C27.7339 27.5723 32.4444 35.5449 38.541 42.2696",
    stroke: "#FFC200",
    strokeWidth: 8.87143,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4551 47.3562C83.9023 43.6912 88.1073 39.5182 91.7107 35.0137",
    stroke: "#FFC200",
    strokeWidth: 8.87143,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0653 94.707C34.0872 100.248 28.5357 106.416 23.1289 112.516",
    stroke: "#FFC200",
    strokeWidth: 8.87143,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2354 107.412C77.8879 108.41 78.6751 109.319 79.3861 110.277",
    stroke: "#FFC200",
    strokeWidth: 8.87143,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8281 164.328C71.2505 162.912 72.7234 161.546 74.124 160.107",
    stroke: "#FFC200",
    strokeWidth: 8.87143,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.67 118.24C117.964 112.544 123.44 106.285 128.74 99.6699",
    stroke: "#FFC200",
    strokeWidth: 8.87143,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.206 164.82C120.627 169.438 125.792 178.945 130.926 185.89",
    stroke: "#FFC200",
    strokeWidth: 8.87143,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer1);
export default __webpack_public_path__ + "static/media/offer1.8ee880d795eef2d0ba55833585d522ff.svg";
export { ForwardRef as ReactComponent };